import { render } from "./twelve-popular.vue?vue&type=template&id=78c34bdf"
import script from "./twelve-popular.vue?vue&type=script&lang=js"
export * from "./twelve-popular.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__